var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPax(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7143_48449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98174 15.9886C5.8174 15.9886 3.65306 15.9658 1.48937 15.9996C0.578684 16.0139 -0.0637327 15.3256 0.0044713 14.5074C0.0427954 14.0457 -0.0234599 13.5697 0.0544875 13.1178C0.250655 11.984 1.02948 11.2678 1.9577 10.7029C3.13471 9.98663 4.43513 9.62299 5.79012 9.41844C6.90736 9.25026 8.02721 9.19702 9.15095 9.29507C11.1068 9.46585 12.9918 9.87624 14.6001 11.0925C15.5212 11.7892 16.0772 12.6853 15.9915 13.8938C15.9746 14.1308 15.9895 14.3697 15.9889 14.6081C15.985 15.4327 15.4368 15.986 14.6047 15.9873C12.3975 15.9912 10.1896 15.9886 7.98239 15.9886H7.98174Z",
    fill: "#D9A62E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98123 8.57923C5.62787 8.57728 3.70842 6.64546 3.70972 4.27923C3.71102 1.9078 5.64281 -0.00389016 8.03385 5.94474e-06C10.3833 0.00390205 12.2917 1.94027 12.2885 4.31559C12.2852 6.66624 10.3515 8.58117 7.98058 8.57923H7.98123Z",
    fill: "#D9A62E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7143_48449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPax);
export default __webpack_public_path__ + "static/media/pax.6a7c62165ef63272d6d96c968854913d.svg";
export { ForwardRef as ReactComponent };